import { render, staticRenderFns } from "./AddRepairs.vue?vue&type=template&id=5e61879d"
import script from "./AddRepairs.vue?vue&type=script&lang=js"
export * from "./AddRepairs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports